import {useMemo} from 'react';

import {HoobiizMediaItem} from '@shared/dynamo_model';
import {useSsrContext} from '@shared/frontends/use_ssr_context';
import {hoobiizMediaId} from '@shared/lib/hoobiiz/hoobiiz_ids';
import {SanitizedItem} from '@shared/model/search_tables';

import {Image, ImageDimension, ImageFullProps} from '@shared-frontend/components/core/image';
import {Custom} from '@shared-frontend/lib/react';

import {hoobiizMediaToProps} from '@src/lib/hoobiiz_media';

interface HoobiizMediaViewProps {
  media?: SanitizedItem<'HoobiizMedia'>;
  size?: ImageDimension;
}

export const HoobiizMediaView: Custom<
  HoobiizMediaViewProps & Partial<ImageFullProps>,
  'img'
> = props => {
  const {media, size = {width: '100%', height: '100%'}, className, ...extraProps} = props;
  const {host} = useSsrContext();

  const imageProps = useMemo<ImageFullProps>(() => {
    if (media) {
      return hoobiizMediaToProps(host, media, size);
    }
    const fakeId = hoobiizMediaId();
    return hoobiizMediaToProps(
      host,
      {
        id: fakeId,
        media: {
          id: fakeId,
          placeholder: {
            width: 1,
            height: 1,
            base64: 'UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAkA4JaQAA3AA/vYkAAA=',
          },
          versions: [] as HoobiizMediaItem['versions'],
        },
      },
      size
    );
  }, [media, host, size]);

  return <Image {...imageProps} lazyLoading cover pictureProps={{className}} {...extraProps} />;
};

HoobiizMediaView.displayName = 'HoobiizImageView';
